// CRUD lives inside /settings/* (see SettingsLayout), not as Resource routes.
// Kept registered for recordRepresentation / permission checks only.
export default {
    recordRepresentation: (record: { title?: string; id?: number }) =>
        record?.title || `Help document #${record?.id ?? ''}`,
};
